import * as fromActions from '../actions';
import * as fromModels from '../../models';

export interface OpusJobDetailsState {
  loadingCharges: boolean;
  loadedCharges: boolean;
  updated: boolean;
  updating: boolean;
  errors: any[];
  opusJobs: fromModels.OpusJob[];
}

export const initialState: OpusJobDetailsState = {
  loadingCharges: false,
  loadedCharges: false,
  updating: false,
  updated: true,
  errors: null,
  opusJobs: null
};

export function reducer(state = initialState, action: fromActions.OpubJobsActions): OpusJobDetailsState {
  switch (action.type) {
    case fromActions.OpusJobsActionTypes.LoadOpusJobs: {
      return {
        ...state,
        loadingCharges: true,
        loadedCharges: false,
        opusJobs: null
      };
    }

    case fromActions.OpusJobsActionTypes.LoadOpusJobsSuccess: {
      return {
        ...state,
        loadingCharges: false,
        loadedCharges: true,
        errors: null,
        opusJobs: [...action.payload]
      };
    }

    case fromActions.OpusJobsActionTypes.LoadOpusJobsFailure: {
      return {
        ...state,
        loadingCharges: false,
        loadedCharges: false,
        errors: action.payload,
        opusJobs: null
      };
    }

    case fromActions.OpusJobsActionTypes.UpdateOpusJobs: {
      return {
        ...state,
        updating: true,
        updated: false
      };
    }

    case fromActions.OpusJobsActionTypes.UpdateOpusJobsFailure: {
      return {
        ...state,
        updating: false,
        updated: false,
        errors: action.payload
      };
    }

    case fromActions.OpusJobsActionTypes.UpdateOpusJobsSuccess: {
      const opusJobs = state.opusJobs.map((sc: fromModels.OpusJob) => {
        const changed = action.payload.changed.find((c: fromModels.OpusJob) => c.id === sc.id);
        if (changed) {
          return changed;
        } else {
          return sc;
        }
      });
      return {
        ...state,
        updating: false,
        updated: true,
        errors: null,
        opusJobs: opusJobs
      };
    }

    default: {
      if (Object.values(fromActions.OpusJobsActionTypes).includes((action as fromActions.OpubJobsActions).type)) {
        console.log('opus-jobs.reducer: unhandled action: ', action);
      }
    }
  }

  return state;
}
